export const MY_HOME_BY_FLAT_NUMBER = 'valuation_my_home_by_flat_number';

export const EXPERIMENTS_NAMES = [MY_HOME_BY_FLAT_NUMBER];
